<template>
  <el-card>
    <el-radio-group v-model="activeName" class="radioGroup" @change="handleClick">
      <el-radio-button label="detail">基础信息</el-radio-button>
      <el-radio-button label="position" v-if="deviceType !== '10' && deviceType !== '8'">坐标</el-radio-button>
      <el-radio-button label="record">分配记录</el-radio-button>
    </el-radio-group>
    <div class="main">
      <el-form v-show="activeName === 'detail'" label-position="right" label-width="80px" class="global-form2">
        <el-form-item label="设备串号">{{ deviceInfo.deviceNumber }}</el-form-item>
        <el-form-item label="分配状态">{{ deviceInfo.allotStatus === '1' ? '已分配' : deviceInfo.allotStatus === '2' ? '未分配' :
          ''}}</el-form-item>
        <el-form-item label="项目名称">{{ deviceInfo.projectName }}</el-form-item>
        <el-form-item label="设备状态">{{ deviceInfo.deviceStatus === '1' ? '在线' : deviceInfo.deviceStatus === '2' ? '离线' :
          ''}}</el-form-item>
        <template v-if="isEdit">
          <el-form-item prop="deviceName" label="设备名称" required :error="editErr">
            <el-input v-model="deviceInfo.deviceName" placeholder="请输入设备名称" maxLength="50" show-word-limit />
          </el-form-item>
          <el-form-item class="marLeft">
            <el-button type="primary" @click="onSave" :loading="loading">保存</el-button>
          </el-form-item>
        </template>
        <template v-else>
          <el-form-item label="设备名称">
            {{ deviceInfo.deviceName }}
          </el-form-item>
          <el-form-item class="marLeft">
            <el-button type="primary" @click="isEdit = true" v-show="$ButtonShow('EDT_01')">编辑</el-button>
          </el-form-item>
        </template>
      </el-form>
      <div v-show="activeName === 'position'" class="positionMain">
        <div id="container"></div>
        <!-- <div class="operation global-form">
          <el-input id="tipinput" v-model='siteName' placeholder="输入地点检索"></el-input>
        </div> -->
        <el-button :loading="loading" type="primary" @click="submitPosition" v-show="$ButtonShow('EDT_01') && !isCad">保存</el-button>
      </div>
      <div v-show="activeName === 'record'">
        <el-table v-loading="loading" :data="tableData" class="global-table">
          <el-table-column label="操作动作">
            <template>分配</template>
          </el-table-column>
          <el-table-column label="项目名称" prop="projectName"></el-table-column>
          <el-table-column label="分配时间" prop="allotTime"></el-table-column>
          <el-table-column label="分配人" prop="allotUserName"></el-table-column>
        </el-table>

        <global-pagination @size-change="loadData" @current-change="loadData" :current-page.sync="page"
          :page-size.sync="size" :total="total">
        </global-pagination>
      </div>
    </div>
  </el-card>
</template>

<script>
import { vjEnv } from '@/utils/config'
import { getPolygons, px2vw } from '@/utils/util'
import { deviceAjax, getMapIcon, deviceTypeParamList, updateAjax } from '@/views/device/mapIcon'
// import vjmap from 'vjmap'
// import 'vjmap/dist/vjmap.min.css'
export default {
  name: 'DeviceDetail',
  components: {
  },
  data () {
    return {
      activeName: 'detail',
      deviceInfo: {
        deviceName: '',
        deviceNumber: '',
        deviceStatus: '',
        allotStatus: ''
      },
      isEdit: false,
      editErr: '',
      deviceId: '',
      loading: false,
      longitude: 118.78,
      latitude: 32.07,
      marker: [],
      siteName: '',
      page: 1,
      size: 10,
      total: 0,
      tableData: [],
      // 土壤温湿 虫情 水质监测 空气质量 水表 智慧断路器 智慧监控 垃圾桶
      detailUrlList: [
        this.$apis.iot.selectSoilInfoByDeviceNumber,
        this.$apis.iot.selectInsectInfoByDeviceNumber,
        this.$apis.iot.selectWaterQualityInfoByDeviceNumber,
        this.$apis.iot.selectWeatherInfoByDeviceNumber,
        this.$apis.iot.selectWaterInfoByDeviceNumber,
        this.$apis.iot.selectJgCircuitBreakerInfoByDeviceNumber,
        this.$apis.iot.selectCameraDemoInfoByDeviceNumber,
        this.$apis.iot.selectTrashcanInfoByDeviceNumber,
        this.$apis.iot.selectJgMowingInfoByDeviceNumber,
        this.$apis.iot.selectJgIrrigationValveByDeviceNumber,
        this.$apis.iot.selectWorkerInfoByDeviceNumber,
        this.$apis.iot.selectWorkerInfoByDeviceNumber,
        this.$apis.iot.selectWaterLyInfoByDeviceNumber,
        this.$apis.iot.selectJgSprayInfoByDeviceNumber
      ],
      locationUrlList: [
        this.$apis.iot.updateSoilInfoLocation,
        this.$apis.iot.updateInsectInfoLocation,
        this.$apis.iot.updateWaterQualityInfoLocation,
        this.$apis.iot.updateWeatherInfoLocation,
        this.$apis.iot.updateWaterInfoLocation,
        this.$apis.iot.updateJgCircuitBreakerInfoLocation,
        this.$apis.iot.updateCameraDemoInfoLocation,
        this.$apis.iot.updateTrashcanInfoLocation,
        this.$apis.iot.updateMowingInfoLocation,
        this.$apis.iot.updateJgIrrigationValveLocation,
        this.$apis.iot.updateWorkerInfoName,
        this.$apis.iot.updateWorkerInfoName,
        this.$apis.iot.updateWaterLyInfoLocation,
        this.$apis.iot.updateJgSprayInfoLocation
      ],
      info: {
        objectId: '',
        deviceNumber: '',
        objectType: '',
        projectId: ''
      }
    }
  },
  computed: {
    deviceNumber () {
      return this.$route.query.deviceNumber
    },
    deviceTypeQuery () {
      return this.$route.query.deviceType
    },
    projectId () {
      return this.$route.query.projectId
    },
    mapCenter () {
      const project = this.projectInfo
      return [+project.longitude || 118.7587, +project.latitude || 31.9686]
    },
    projectInfo () {
      return this.$store.state.projectList.find(item => item.projectId === this.projectId) || {}
    },
    cadEpsg () {
      return this.projectInfo.epsg
    },
    isCad () {
      return !!this.projectInfo.cadId
    },
    deviceType () {
      const map = new Map()
      map.set('0', '1001') // 土壤
      map.set('1', '1017') // 智慧虫情
      map.set('2', '1015') // 水质监测
      map.set('3', '1012') // 环境监测
      map.set('4', '1004') // 智慧水表
      map.set('5', '1014') // 智慧电表
      map.set('6', '1002') // 智慧监控
      map.set('7', '1011') // 智慧垃圾桶
      map.set('8', '') // 割草机器人
      map.set('9', 'penguan') // 电磁阀
      map.set('10', '') // 工牌手环
      return map.get(this.deviceTypeQuery)
    },
    detailMarkInfo () {
      return {
        deviceType: this.deviceType,
        isCurrent: true,
        longitude: this.longitude || '',
        latitude: this.latitude || ''
      }
    },
    noAllotStatus () {
      return this.deviceInfo.allotStatus !== '1'
    }
  },
  mounted () {
    this.popup = null
    this._popup = null
    this.getDetail()
    this.loadData()
  },
  beforeDestroy () {
    this._map && this._map.remove()
    this._map = null
    this.clearOverlayer()
  },
  methods: {
    getDetail () {
      this.loading = true
      this.$axios.get(this.detailUrlList[Number(this.deviceTypeQuery)], {
        deviceNumber: this.deviceNumber
      }).then((res) => {
        this.deviceInfo = res
      }).finally(() => {
        this.loading = false
      })
    },
    handleClick () {
      if (this.activeName === 'position') {
        if (this.deviceInfo.longitude && this.deviceInfo.latitude) {
          this.longitude = parseFloat(this.deviceInfo.longitude)
          this.latitude = parseFloat(this.deviceInfo.latitude)
        }
        this.clearOverlayer()
        // const lng = Number(this.longitude)
        // const lat = Number(this.latitude)
        this.$nextTick(async () => {
          // this.loadMap(lng, lat)
          if (!this._map) {
            await this.initMap()
          }
          // 未分配
          // setTimeout(() => {
          if (this.noAllotStatus) {
            // console.log('未分配============')
            this.addCadMarker(this._map, [this.detailMarkInfo], true)
            this.setFitMarkers()
            this.$message.warning('请先分配设备')
          } else {
            if (this.isCad) { // 加载cad设备，进行绑定并打点
              this.loadCadDevices()
              this.setFitMarkers()
            } else {
              // console.log('没有cad但是有分配项目============')
              this.loadLocationList()
              if (this.longitude && this.latitude) {
                this.addCadMarker(this._map, [this.detailMarkInfo], true)
                // 进行打点
              }
            }
          }
          // }, 100)
        })
      }
    },
    async loadCadDevices () {
      const deviceType = this.deviceType
      const data = await this.$axios.get(deviceAjax.get(deviceType), { projectId: this.projectId })
      const list = (deviceTypeParamList.get(deviceType) ? data[deviceTypeParamList.get(deviceType)].list : data.list).map(item => {
        return { ...item, deviceType: deviceType }
      })
      this.addCadMarker(this._map, list)
    },
    addCadMarker (map, list, draggable) {
      list.forEach(item => {
        const current = item.isCurrent
        const el = document.createElement('div')
        el.className = 'marker'
        el.style.backgroundImage = `url('${getMapIcon(item.deviceType, item)}')`
        el.style.width = current ? '40px' : !item.deviceNumber ? '48px' : '36px'
        el.style.height = current ? '40px' : '48px'
        el.style.backgroundSize = '100%'
        if (this.isCad && item.objectX && item.objectY) {
          const cadPoints = vjmap.geoPoint([item.objectX, item.objectY])
          const lngLat = this.cadToWebCoordinate(cadPoints)
          item.longitude = lngLat[0]
          item.latitude = lngLat[1]
        }
        const co = [item.longitude, item.latitude]
        const marker = new vjmap.Marker({
          element: el,
          anchor: 'bottom'
        })
        marker.setLngLat(co).addTo(map)
        if (draggable) {
          this._map.on('click', this.moveMarker)
        }
        el.addEventListener('click', (e) => {
          this.$confirm('确定绑定此设备?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            this.info.objectId = item.objectId
            this.info.deviceNumber = this.deviceInfo.deviceNumber
            this.info.projectId = this.projectId
            this._bindDeviceInfo = item
            this.onSubmit()
          }).catch(() => {
            // 1
          })
        })
        this.marker.push(marker)
      })
      // this.setFitMarkers()
    },
    moveMarker (e) {
      this.marker[0].remove()
      this.marker[0].setLngLat(e.lngLat).addTo(this._map)
    },
    onSubmit () {
      this.$axios.post(this.$apis.device.updateJgCad, this.info).then(res => {
        this.$message.success('绑定成功')
        this.updateLocation()
        this.clearOverlayer()
        this.loadCadDevices()
      })
    },
    updateLocation () {
      this.$axios.post(updateAjax.get(this.deviceType), {
        deviceNumber: this.info.deviceNumber,
        longitude: this._bindDeviceInfo.longitude,
        deviceName: this.deviceInfo.deviceName,
        latitude: this._bindDeviceInfo.latitude
      }).then(() => {
        this.$message.success('保存成功')
        this.isEdit = false
      })
    },
    removeMarker () {
      if (this.marker.length > 0) {
        this.marker.forEach(item => item.remove())
      }
      this.marker = []
    },
    clearOverlayer () {
      this.removeMarker()
    },
    // 地图自适应展示全部markers，padding为四周留白距离 数值为数字或者对象，eg：10 或 {top: 10, bottom:25, left: 15, right: 5}，maxZoom为最大放大等级
    setFitMarkers (padding, maxZoom) {
      const pd = padding || px2vw(100)
      const mZoom = maxZoom || 18
      const markers = this._map.getMarkers()
      if (markers.length) {
        const pts = markers.map(c => this._map.fromLngLat(c.getLngLat()))
        const showBounds = vjmap.geoBounds()
        showBounds.update(pts) // 得到所有点坐标的范围
        const lngLatBounds = this._map.toLngLat(showBounds)
        this._map.fitBounds(lngLatBounds, {
          padding: pd,
          maxZoom: mZoom,
          duration: 500
        })
      }
    },
    cadToWebCoordinate (point) {
      const cadEpsg = this.cadEpsg || 'EPSG:4549' // cad图的espg代号
      const co = proj4(cadEpsg, 'EPSG:4326', point)
      // 把wgs84转成高德坐标坐标
      return vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
    },
    loadData () {
      this.loading = true
      this.$axios.get(this.$apis.iot.selectDeviceAllotByPage, {
        deviceNumber: this.deviceNumber,
        page: this.page,
        size: this.size
      }).then(res => {
        this.tableData = res.list
        this.total = res.total
      }).finally(() => {
        this.loading = false
      })
    },
    onSave () {
      if (this.deviceInfo.deviceName) {
        this.editErr = ''
        this.loading = true
        this.$axios.post(this.locationUrlList[Number(this.deviceTypeQuery)], {
          deviceNumber: this.deviceNumber,
          longitude: this.deviceInfo.longitude,
          deviceName: this.deviceInfo.deviceName,
          latitude: this.deviceInfo.latitude
        }).then(() => {
          this.getDetail()
          this.$message.success('保存成功')
          this.isEdit = false
        }).finally(() => {
          this.loading = false
        })
      } else {
        this.editErr = '请输入设备名称'
      }
    },
    // loadMap (lng, lat) {
    //   AMapLoader.load({
    //     key: mapKey,
    //     version: '2.0',
    //     plugins: []
    //   }).then(() => {
    //     const map = new AMap.Map('container', {
    //       center: [this.longitude, this.latitude],
    //       zoom: 15
    //     })
    //     if (lng && lat) {
    //       this.addMarker(map, lng, lat)
    //     }
    //     if (this.deviceInfo.projectId) {
    //       this.loadLocationList(map)
    //     } else {
    //       this.$message.warning('请先分配设备')
    //     }
    //     map.on('click', (e) => {
    //       this.setLngLat(e.lnglat.getLng(), e.lnglat.getLat())
    //       this.addMarker(map, this.longitude, this.latitude)
    //     })
    //     // 输入提示
    //     const autoOptions = {
    //       input: 'tipinput'
    //     }
    //     AMap.plugin(['AMap.PlaceSearch', 'AMap.AutoComplete'], () => {
    //       const auto = new AMap.AutoComplete(autoOptions)
    //       auto.on('select', (e) => {
    //         map.setZoomAndCenter(16, [e.poi.location.lng, e.poi.location.lat])
    //       })
    //     })
    //   })
    // },
    async initMap () {
      // --高德地图(地图数据前端获取)--
      const svc = new vjmap.Service(vjEnv.serviceUrl, vjEnv.accessToken)
      this._svc = svc
      // 根据地图范围建立经纬度投影坐标系
      const prj = new vjmap.LnglatProjection()
      // wgs84坐标
      const coWgs84 = prj.toLngLat(this.mapCenter)
      // 把wgs84转成高德坐标坐标
      const coGCJ02 = vjmap.transform.convert(coWgs84, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
      // 地图对象
      this._map = new vjmap.Map({
        container: 'container', // DIV容器ID
        style: {
          version: svc.styleVersion(),
          glyphs: svc.glyphsUrl(),
          sources: {
            gaodeRoadSource: {
              type: 'raster',
              tiles: ['https://webrd02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}']
            },
            // 影像无文字注记
            gaodeImgSource: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=6&x={x}&y={y}&z={z}'
              ]
            },
            // 影像文字注记
            gaodeImgSourceLabel: {
              type: 'raster',
              tiles: [
                'https://webst02.is.autonavi.com/appmaptile?lang=zh_cn&size=1&scale=1&style=8&x={x}&y={y}&z={z}'
              ]
            }
          },
          layers: [{
            id: 'gaodeRoad',
            type: 'raster',
            source: 'gaodeRoadSource'
          }, {
            id: 'gaodeImg',
            type: 'raster',
            source: 'gaodeImgSource',
            layout: {
              visibility: 'none'
            }
          }, {
            id: 'gaodeImgLabel',
            type: 'raster',
            source: 'gaodeImgSourceLabel',
            layout: {
              visibility: 'none'
            }
          }]
        },
        center: prj.toLngLat(coGCJ02),
        zoom: 15,
        pitch: 0,
        renderWorldCopies: false // 不显示多屏地图
      })

      // 关联服务对象和投影对象
      this._map.attach(svc, prj)
      // 根据地图本身范围缩放地图至全图显示
      await this._map.onLoad()

      // 加载proj4库，用于坐标转换
      if (typeof proj4 !== 'object') {
        // 如果没有环境
        await vjmap.addScript([{
          src: 'https://vjmap.com/demo/js/proj4.min.js'
        }])
      }
      if (this.isCad) {
        const res = await this.openCAD()
        await this.addDefaultLayer(res)
      }
    },
    async addDefaultLayer (res) {
      const cadEpsg = this.cadEpsg
      const wmsUrl = this._svc.wmsTileUrl({
        mapid: this.projectInfo.cadId, // 地图id
        layers: res.layer, // 图层名称
        srs: 'EPSG:3857',
        crs: cadEpsg,
        webMapType: 'GCJ02' // 底图是高德地图，所以要选GCJ02,如果是天地图，可以不用填此项
      })
      this._map.addSource('wms-test-source', {
        type: 'raster',
        tiles: [
          wmsUrl
        ],
        tileSize: 256
      })
      this._map.addLayer({
        id: 'wms-test-layer',
        type: 'raster',
        source: 'wms-test-source',
        paint: { 'raster-opacity': 1 }
      }
      )
      await this.initEpsgProj({
        longitude: this.mapCenter[0],
        latitude: this.mapCenter[1]
      }, this.projectInfo.cadId)
      proj4.defs('EPSG:4326', '+proj=longlat +datum=WGS84 +no_defs +type=crs')
      // proj4.defs(cadEpsg, epsgArr[0].proj)
      // cad图坐标转web wgs84坐标，再转火星坐标（高德)
      const cadToWebCoordinate = point => {
        const co = proj4(cadEpsg, 'EPSG:4326', vjmap.geoPoint(point).toArray())
        // 把wgs84转成高德坐标坐标
        const dataaaa = vjmap.transform.convert(co, vjmap.transform.CRSTypes.WGS84, vjmap.transform.CRSTypes.GCJ02)
        return dataaaa
      }
      // // 火星坐标（高德)转web wgs84坐标转cad图坐标
      // const webTocadCoordinate = point => {
      //   const co = vjmap.transform.convert(point, vjmap.transform.CRSTypes.GCJ02, vjmap.transform.CRSTypes.WGS84)
      //   return proj4('EPSG:4326', cadEpsg, co)
      // }
      // 根据cad图的中心点，计算wgs84的中心点坐标
      const mapBounds = vjmap.GeoBounds.fromString(res.bounds)
      const cadCenter = mapBounds.center()
      // if (String(parseInt(cadCenter.x)).length === 8) {
      //   cadCenter.x = parseFloat(String(cadCenter.x).slice(2))
      // }
      // console.log('cadCenter', cadCenter)
      const webCenter = cadToWebCoordinate(cadCenter)
      // 把cad图的中点设置为地图的中心点
      console.log('webCenter', webCenter)
      this._map.setCenter(webCenter)
    },
    async openCAD (mapid, fileid) {
      const mapId = mapid || this.projectInfo.cadId
      console.log('mapId', mapId)
      console.log('fileid', fileid)
      this._svc.switchWorkspace(vjEnv.workspace)
      const res = await this._svc.openMap({
        fileid: fileid,
        mapid: mapId, // 地图ID,(请确保此ID已存在，可上传新图形新建ID)
        // mapopenway: vjmap.MapOpenWay.GeomRender, // 以几何数据渲染方式打开
        mapopenway: vjmap.MapOpenWay.Memory,
        style: vjmap.openMapDarkStyle() // div为深色背景颜色时，这里也传深色背景样式
      })
      return res
    },
    setPopupText (text) {
      if (text) {
        if (!this.popup) {
          this.popup = new vjmap.Popup({
            className: 'custom-popup',
            closeOnClick: false,
            closeButton: false
          })
            .setHTML(text)
            .setMaxWidth('500px')
            .trackPointer()
            .addTo(this._map)
        } else {
          this.popup.setHTML(text)
        }
      } else {
        // 如果为空时，则删除popup
        if (this.popup) {
          this.popup.setLngLat([0, 0]) // 取消trackPointer
          this.popup.remove()
          this.popup = null
        }
      }
    },
    async initEpsgProj ({ longitude, latitude }, mapId) {
      const metadata = await this._svc.metadata(mapId, 'v1')
      const x = longitude
      const y = latitude
      const cadX = String(parseInt(metadata.initCenterX))
      let res = []
      if (cadX.length === 8) {
        const proj = vjmap.transform.getEpsgParam(vjmap.transform.EpsgCrsTypes.CGCS2000, parseInt(cadX.slice(0, 2)))
        res.push(proj)
      } else {
        res = vjmap.transform.getEpsgCode([x, y], vjmap.transform.EpsgCrsTypes.CGCS2000, '')
      }
      console.log('pro4', res)
      for (const item of res) {
        if (item.proj) {
          proj4.defs(item.epsg, item.proj)
        }
        if (x < 180) {
          // 经纬度转 cad投影坐标
          item.convertCoordinate = proj4('EPSG:4326', item.epsg, [x, y])
        } else {
          // cad投影坐标转经纬度
          item.convertCoordinate = proj4(item.epsg, 'EPSG:4326', [x, y])
        }
      }
      console.log('最终的pro', res)
      return res
    },
    async getMapEpsg ({ longitude, latitude }, mapId) {
      const res = await this.initEpsgProj({ longitude, latitude }, mapId)
      const metadata = await this._svc.metadata(mapId, 'v1')
      const point1 = {
        x: parseFloat(metadata.initCenterX),
        y: parseFloat(metadata.initCenterY)
      }
      if (String(parseInt(point1.x)).length === 8) {
        point1.x = parseFloat(String(point1.x).slice(2))
      }
      for (const i of res) {
        const distance = this.calculateDistance(point1, {
          x: i.convertCoordinate[0],
          y: i.convertCoordinate[1]
        })
        i.distance = distance
      }
      const newEpsgArr = res.sort((a, b) => {
        return a.distance - b.distance
      })
      const cadEpsg = newEpsgArr[0].epsg
      console.log('cadEpsg', cadEpsg)
      return cadEpsg
      // setEpsgText(JSON.stringify(res, null, 4))
    },
    async measureCoordinate () {
      let isDrawing = false
      const point = await vjmap.Draw.actionDrawPoint(this._map, {
        api: {
          // getSnapFeatures: snapObj // 要捕捉的数据项在后面，通过属性features赋值
          getSnapFeatures: {} // 要捕捉的数据项在后面，通过属性features赋值
        },
        updatecoordinate: (e) => {
          if (!e.lnglat) return
          isDrawing = true
          const co = this._map.fromLngLat(e.lnglat)
          const html = `当前坐标:<span style="color: #ff0000"> ${co.x.toFixed(8)}, ${co.y.toFixed(8)}</span>`
          this.setPopupText(html)
        },
        contextMenu: (e) => {
          const ss = new vjmap.ContextMenu({
            event: e.event.originalEvent,
            theme: 'dark', // light
            width: '250px',
            items: [
              {
                label: '确认',
                onClick: () => {
                  // 给地图发送Enter键消息即可取消，模拟按Enter键
                  this._map.fire('keyup', { keyCode: 13 })
                  this.setPopupText('')
                }
              },
              {
                label: '取消',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  this.setPopupText('')
                }
              },
              {
                label: '结束测坐标',
                onClick: () => {
                  // 给地图发送ESC键消息即可取消，模拟按ESC键
                  this._map.fire('keyup', { keyCode: 27 })
                  isDrawing = false
                  this.setPopupText('')
                }
              }
            ]
          })
          console.log('ss', ss)
        }
      })
      if (point.cancel) {
        this.setPopupText('')
        return {
          cancel: true,
          exit: isDrawing === false
        }// 取消操作
      }

      this.addMarkersToCoord(point.features[0].geometry.coordinates)
      return {
        point
      }
    },
    // 给加个测量的结果值
    addMarkersToPolygon (coordinates, fenceCode, style, status = false) {
      const polygon = new vjmap.Polygon({
        data: coordinates,
        fillColor: style.fillColor,
        fillOpacity: style.fillOpacity || 0.8,
        fillOutlineColor: style.fillOutlineColor
      })
      polygon.addTo(this._map)
      if (!status) {
        return
      }
      let markerTexts = []
      // 给第一个点加一个marker用来删除
      const deletePng = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAAXNSR0IArs4c6QAAAbNJREFUWEftlrFOAkEQhv9Z4XgJOCrlTgp5ABOhMBoTCws7EzUaeAx5A0sDiYmFxpLGaAkU2KqFArHi4CU4cMccAQN6HHcIwZi7cnd25tt/5maHsOCPFhwfPoAnBarhQFIIccjAkV3qCMhKKct6q1tym1pPAHVVOWMg6+ScgKuYYR7PBaCmKmw5XgLiy4b5NhzkXVVWP4BXa00zTNcXc21oOR4AjAswaX9M2n4u1yLBIoiSbmV0Zcdc0pqd1HdbWwUWDuDqRjMy8lQDM4o54sYRoJcKq6qHclePKnuScQ0pd/RWt2ztVyOhLUFckIwTvWneDiLYnXdVA18O+r/dcNXXIsozCGsMzuhGJ98DUINpAuUAqmhGe33k/JjiG9g4K2ADUFdDOQan7QAIlI8Z7YwP4CvgK/C/FahFlQcwtm0bEeNFa5qJuSpgdT2AzkFyU290H3udMBzYgBD3gnAQa5iFuQJ4eZB6A8ovW/ETgARLmfIyaPZVSZIQRTBdas326Thwx7fAzRA6SREB2l0x2ndTAfTnwH0CrGk4PinY6D5VQHyhNcwbp3N/eyDxduPprH0FPgHEyH4wGIHUYwAAAABJRU5ErkJggg=='
      const el = document.createElement('div')
      el.className = 'marker'
      el.style.backgroundImage =
        `url(${deletePng})`
      el.style.width = '20px'
      el.style.height = '20px'
      el.style.backgroundSize = '100%'
      el.style.cursor = 'pointer'

      el.addEventListener('click', (e) => {
        this._map.removeSourceEx(polygon.sourceId) // 删除绘制的线
        markerTexts.forEach(m => m.remove())
        markerTexts = []
        this.info.locationList = this.info.locationList.filter(item => item.fenceCode !== fenceCode)
      })
      // Add markers to the map.
      const deleteMarker = new vjmap.Marker({
        element: el,
        anchor: 'right'
      })
      deleteMarker.setLngLat(coordinates[0])
        .setOffset([-5, 0])
        .addTo(this._map)
      markerTexts.push(deleteMarker)

      this._map.fire('keyup', { keyCode: 27 })
      this.setPopupText('')

      // 把坐标加进捕捉数组中。
      // addSnapCoordinates(coordinates);
    },
    // 画电子围栏
    loadLocationList () {
      this.$axios.get(this.$apis.project.selectJgProjectMapByProjectId, {
        projectId: this.deviceInfo.projectId
      }).then((res) => {
        if (res && res.locationList && res.locationList.length && !this.isCad) {
          const polygons = getPolygons(res.locationList)
          console.log('polygons', polygons)
          polygons.forEach(item => {
            this.addMarkersToPolygon(item[1], item[0], {
              fillColor: '#36cbcb',
              fillOutlineColor: '#36cbcb',
              fillOpacity: 0.5
            })
          })
        }
        // // 画电子围栏
        // drawPolygon(map, res.locationList, null, (e) => {
        //   this.setLngLat(e.lnglat.getLng(), e.lnglat.getLat())
        //   this.addMarker(map, this.longitude, this.latitude)
        // })
      })
    },
    setLngLat (lng, lat) {
      this.longitude = lng
      this.latitude = lat
    },
    // addMarker (map, lng, lat) {
    //   if (this.marker) {
    //     map.remove(this.marker)
    //   }
    //   this.marker = new AMap.Marker({
    //     map: map,
    //     position: new AMap.LngLat(lng, lat),
    //     offset: new AMap.Pixel(-20, -40),
    //     icon: LocationImg,
    //     draggable: true
    //   })
    //   this.marker.on('dragend', (e) => {
    //     this.setLngLat(e.lnglat.getLng(), e.lnglat.getLat())
    //   })
    //   this.setLngLat(lng, lat)
    //   this.marker.on('dragstart', (e) => {
    //     this.marker.setPosition(new AMap.LngLat(e.lnglat.lng, e.lnglat.lat))
    //   })
    //   map.add(this.marker)
    // },
    submitPosition () {
      this.loading = true
      const lngLat = this.marker[0].getLngLat()
      this.longitude = lngLat.lng.toString()
      this.latitude = lngLat.lat.toString()
      this.$axios.post(this.locationUrlList[Number(this.deviceTypeQuery)], {
        deviceNumber: this.deviceNumber,
        longitude: this.longitude,
        deviceName: this.deviceInfo.deviceName,
        latitude: this.latitude
      }).then(() => {
        this.getDetail()
        this.$message.success('保存成功')
        this.isEdit = false
      }).finally(() => {
        this.loading = false
      })
    }
  }
}
</script>

<style scoped lang='scss'>
::v-deep .el-card__body {
  padding: 0;
  height: 100%;
}

.main {
  width: 100%;
  height: calc(100% - 68px);
  padding: 20px 40px;
  border-top: 1px solid #F4F4F4;
  overflow-y: auto;
}

.marLeft {
  ::v-deep .el-form-item__content {
    margin-left: 10px !important;
  }
}

.positionMain {
  position: relative;
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: flex-start;

  #container {
    max-width: 100%;
    width: 1200px;
    height: 600px;
    overflow: hidden;
    margin: 0;
  }

  .el-button {
    margin-top: 20px;
  }

  .operation {
    position: absolute;
    top: 20px;
    left: 20px;
    z-index: 20;
  }
}

// tab签
.radioGroup {
  height: 28px;
  background: #F0F2F5;
  border-radius: 6px;
  padding: 3px 4px;
  margin: 20px 40px;

  ::v-deep {
    .el-radio-button {
      height: 22px;
      background: transparent;
      padding: 4px 10px;

      .el-radio-button__inner {
        height: 100%;
        font-size: 14px;
        color: #AFAFAF !important;
        border: none !important;
        padding: 0 !important;
        line-height: 14px;
        background-color: transparent;
      }

      &.is-active {
        background: #FFFFFF;
        box-shadow: 0px 1px 2px 0px rgba(188, 188, 188, 0.5);
        border-radius: 6px;

        .el-radio-button__inner {
          font-weight: 500;
          color: #1989FA !important;
          box-shadow: none;
        }
      }
    }
  }
}
.popup{
  width: 400px;
  min-height: 150px;
  font-family: PingFang SC;
  font-weight: 400;
  font-size: 14px;
  background: var(--map-popup-bg);
  border-radius: 10px;
  .header{
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 34px;
    background: #2E3C55;
    padding: 10px 19px;
    color: #FFFFFF;
    border-radius: 10px 10px 0 0;
  }
  .content{
    color: var(--header-bar-title-color);
    padding: 16px 0 0 19px;
  }
}
</style>
